/** Nome de exibição do produto (sem sufixo legado IF). */
export const SYSTEM_DISPLAY_NAME = 'Ingressa';

export const INGRESSA_STORAGE_KEYS = {
  adminSelectedProcess: 'ingressa_admin_selected_process',
  candidateCollapsedProcesses: 'ingressa_candidate_collapsed_processes',
  filtersExamObjective: 'ingressa_filters_exam_objective_admin',
  filtersExamEssay: 'ingressa_filters_exam_essay_admin',
  filtersAppeal: 'ingressa_filters_appeal',
  filtersPayment: 'ingressa_filters_payment',
  filtersSpecialAttendance: 'ingressa_filters_special_attendance_admin',
  filtersAnalysis: 'ingressa_filters_analysis',
};

const LEGACY_MIGRATIONS = [
  ['ingressaif_admin_selected_process', INGRESSA_STORAGE_KEYS.adminSelectedProcess],
  ['ingressaif_candidate_collapsed_processes', INGRESSA_STORAGE_KEYS.candidateCollapsedProcesses],
  ['ingressaif_filters_exam_objective_admin', INGRESSA_STORAGE_KEYS.filtersExamObjective],
  ['ingressaif_filters_exam_essay_admin', INGRESSA_STORAGE_KEYS.filtersExamEssay],
  ['ingressaif_filters_appeal', INGRESSA_STORAGE_KEYS.filtersAppeal],
  ['ingressaif_filters_payment', INGRESSA_STORAGE_KEYS.filtersPayment],
  ['ingressaif_filters_special_attendance_admin', INGRESSA_STORAGE_KEYS.filtersSpecialAttendance],
  ['ingressaif_filters_analysis', INGRESSA_STORAGE_KEYS.filtersAnalysis],
];

function migrateStoreKey(store, oldKey, newKey) {
  try {
    const value = store.getItem(oldKey);
    if (value == null) return;
    if (store.getItem(newKey) == null) store.setItem(newKey, value);
    store.removeItem(oldKey);
  } catch (_) {
    /* ignore */
  }
}

/** Migra chaves localStorage/sessionStorage do legado ingressaif_* → ingressa_*. */
export function migrateIngressaBrowserStorage() {
  for (const [oldKey, newKey] of LEGACY_MIGRATIONS) {
    migrateStoreKey(localStorage, oldKey, newKey);
    migrateStoreKey(sessionStorage, oldKey, newKey);
  }
}
